
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'components/Loader'
import {Table, Column, Cell} from 'components/Table'
import {getSelectedDateRange} from 'redux/modules/currentUser/selectors'
import {
  fetchChannelConfigs,
  fetchChannelCosts,
  disconnectIntegration,
  activateCostConnector,
  fetchIntegrations
} from 'redux/modules/integrations/actions'
import {
  getChannelsWithCostConnectors,
  getConnectedChannel,
  getAuthorizationURL,
  getChannelCosts,
  getCostConnectorInfo,
  getIntegration
} from 'redux/modules/integrations/selectors'
import {connect} from 'react-redux'
import propsChanged from 'utils/propsChanged'
import subWeeks from 'date-fns/sub_weeks'
import subDays from 'date-fns/sub_days'
import TimeAgo from 'components/TimeAgo'

export class ChannelIntegrationView extends React.Component {
  static propTypes = {
    today: PropTypes.instanceOf(Date).isRequired,
    channelId: PropTypes.string,
    integrationId: PropTypes.string,
    serviceId: PropTypes.string,
    integration: PropTypes.object,
    authorizationURL: PropTypes.string,
    fetchChannelConfigs: PropTypes.func,
    fetchIntegrations: PropTypes.func,
    activateCostConnector: PropTypes.func,
    fetchChannelCosts: PropTypes.func,
    disconnectIntegration: PropTypes.func,
    connectedChannel: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    channelCosts: PropTypes.array,
    costConnectorInfo: PropTypes.object,
    location: PropTypes.object.isRequired,
    showConnectButtonPlease: PropTypes.bool,
    isBusy: PropTypes.bool
  }

  static contextTypes = {
    timezone: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      accountId: null
    }
  }

  componentDidMount() {
    const {fetchChannelConfigs, fetchIntegrations} = this.props
    fetchChannelConfigs()
    fetchIntegrations()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (propsChanged(this.props, nextProps, ['isBusy'])) {
      const {
        channelId,
        costConnectorInfo,
        connectedChannel,
        activateCostConnector,
        channelsWithCostConnectors,
        fetchChannelCosts,
        today
      } = nextProps
      const {
        timezone
      } = nextContext

      if (!channelsWithCostConnectors) return null

      if (!connectedChannel) {
        const {costConnectorType} = costConnectorInfo
        activateCostConnector(costConnectorType)
      } else if (connectedChannel.auth) {
        const endDate = subDays(today, 1)
        const startDate = subWeeks(endDate, 1)
        fetchChannelCosts({channelId, startDate, endDate, timezone})
      }
    }
  }

  render() {
    const {isBusy} = this.props

    if (isBusy) return <Loader />

    return (
      <div className='channel-integration-view'>
        {this.renderIntegration()}
      </div>
    )
  }

  renderIntegration() {
    const {authorizationURL, connectedChannel, showConnectButtonPlease, integration} = this.props
    const authorized = integration || (connectedChannel && connectedChannel.auth)

    if (!authorized && !authorizationURL) return <Loader />

    return (
      <div>
        {!authorized || showConnectButtonPlease ? this.renderUnAuthorizedContent() : null}
        {authorized && this.renderAuthorizedContent()}
      </div>
    )
  }

  renderAuthorizedContent() {
    const {channelCosts, integrationId} = this.props
    if (!channelCosts) return <Loader />

    const lastSyncDate = channelCosts.length ? channelCosts[0].day : null

    return (
      <div className='channel-integration-view_authorized'>
        <div className='channel-integration-view_authorized_text container'>
          <div>
            Last Sync: <span className='channel-integration-view_authorized_last-sync'>
              {lastSyncDate ? <TimeAgo date={lastSyncDate} /> : 'No data'}
            </span>
          </div>
          <button
            disabled={!integrationId}
            className='channel-integration-view_authorized_disconnect'
            onClick={this.disconnect}
          >
            Disconnect
          </button>
          {this.renderError()}
        </div>
        <div className='channel-integration-view_authorized_table'>
          <Table
            data={channelCosts}
            empty={
              <div className='channel-integration-view_authorized_table_empty'>
                No data for last 7 days
              </div>
            }
          >
            <Column
              header='Date'
              cell={data => <Cell format='date'>{data.day}</Cell>}
              width='50%'
            />
            <Column
              header={<Cell align='right'>Cost</Cell>}
              cell={data => <Cell align='right' format='currency'>{data.cost}</Cell>}
              width='50%'
            />
          </Table>
        </div>
      </div>
    )
  }

  renderUnAuthorizedContent() {
    const {costConnectorInfo, authorizationURL} = this.props

    if (!costConnectorInfo) return null

    const {title} = costConnectorInfo

    return (
      <div className='channel-integration-view_unauthorized'>
        <div className='channel-integration-view_unauthorized_text'>
          Connection to {title} is automatic. To connect,
           simply click “Connect” below and follow the steps.
        </div>
        <div className='channel-integration-view_unauthorized_connect'>
          <a href={authorizationURL} className='channel-integration-view_button button is-blue'>
            Connect
          </a>
        </div>
        {this.renderError()}
      </div>
    )
  }

  renderError() {
    const {error} = this.props.location.query || {}
    if (!error) return null

    return (
      <div className='channel-integration-view_error'>{error}</div>
    )
  }

  disconnect = () => {
    const {
      disconnectIntegration,
      serviceId,
      integrationId
    } = this.props
    disconnectIntegration(serviceId, integrationId)
  }
}

const mapStateToProps = (state, props) => {
  const {params: {channelId, channelGroupId}, location} = props
  const {integrationId} = location.query || {}
  const {protocol, host} = window.location
  const {pathname} = props.location
  const redirectURL = `${protocol}//${host}${pathname}`
  const {startDate, endDate} = getSelectedDateRange(state)
  const integration = getIntegration(state, integrationId)

  return {
    today: state.today,
    integrationId,
    integration,
    serviceId: integration ? integration.serviceId : null,
    channelId,
    channelsWithCostConnectors: getChannelsWithCostConnectors(state),
    connectedChannel: getConnectedChannel(state, channelId),
    authorizationURL: getAuthorizationURL(state, channelId, redirectURL),
    startDate,
    endDate,
    channelCosts: getChannelCosts(state, channelId),
    costConnectorInfo: getCostConnectorInfo(channelGroupId, channelId),
    isBusy: state.integrations.isChannelConfigFetching || state.integrations.isIntegrationsFetching,
    showConnectButtonPlease: !!props.location.query.connect
  }
}

const mapDispatchToProps = {
  fetchIntegrations,
  fetchChannelConfigs,
  fetchChannelCosts,
  disconnectIntegration,
  activateCostConnector
}

export default connect(mapStateToProps, mapDispatchToProps)(ChannelIntegrationView)



// WEBPACK FOOTER //
// ./client/views/ChannelIntegrationView/index.js